<template>
  <section class="upsell-slider" v-if="products.length">
    <!-- K2-3035: ProductTileSlider picks MiniOpenConfigurator over MiniAddToCart for products
         with custom options, but nothing here used to mount a matching <configurator> instance
         to catch its 'modal-show'/'modal-custom-options-{sku}' bus event - the click was a
         silent no-op. Same fix/pattern as Recommendations.vue. -->
    <configurator v-for="upsellProduct in products"
                  v-if="upsellProduct.custom_options && upsellProduct.custom_options.length > 0"
                  :product="upsellProduct"
                  :key="upsellProduct.entity_id"
                  :category-id="0"
    />
    <header><h3 class="cl-accent">{{ $t('Add to your order') }}</h3></header>
    <product-listing-related columns="4" :products="products" />
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import ProductListingRelated from 'theme/components/core/ProductListingRelated'
import Configurator from 'theme/components/theme/blocks/Home/ProductTileGrid/Configurator'

export default {
  name: 'UpsellSlider',
  components: { ProductListingRelated, Configurator },
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  data () {
    return { products: [] }
  },
  watch: {
    // K2-3006: re-fetch whenever the partner group's own item list changes (qty-only changes
    // don't add/remove ids, so this naturally skips a re-fetch for those) - matches items by
    // entity_id, the same field Product.vue already uses to identify a cart line's underlying
    // catalog product.
    'group.items': {
      immediate: true,
      handler (items, previousItems) {
        let ids = (items || []).map(item => item.entity_id)
        let previousIds = (previousItems || []).map(item => item.entity_id)
        if (ids.length && (!previousItems || ids.join(',') !== previousIds.join(','))) {
          this.loadProducts(ids)
        } else if (!ids.length) {
          this.products = []
        }
      }
    }
  },
  methods: {
    ...mapActions({ loadCartUpsell: 'product/loadCartUpsell' }),
    async loadProducts (ids) {
      this.products = await this.loadCartUpsell({
        ids,
        partnerCode: this.group.partner.code,
        locationCode: this.group.partner.location_code
      }).catch(() => [])
      // ProductTileSlider's activeButtonAddToCart gates the add-to-cart button on
      // product.partner.active/enabled, falling back to the globally "currently browsed"
      // partner when product.partner is absent - which it always is here, since these come
      // straight from the ES product index (partner_code/partner_id only, no nested partner
      // object). That fallback is wrong for cart-upsell items: the relevant partner is this
      // specific cart group's, not whatever partner page happens to be active (or none, if
      // the cart was opened without ever visiting one this session) - so the button silently
      // never rendered. Attach it explicitly so the existing product.partner branch is used.
      this.products.forEach(item => { item.partner = this.group.partner })
      // Tag for add-to-cart/purchase attribution (K2-3012). This action deliberately doesn't go
      // through CATALOG_PRODUCT_SET_RECOMMENDATIONS (see loadCartUpsell's own comment), so there's
      // no mutation for the GTM module to observe - fire view_item_list explicitly via the bus
      // instead of scattering a direct $gtag call into this component.
      if (this.products.length) {
        this.products.forEach(item => { item.recommended = 'cart_upsell' })
        this.$bus.$emit('recommendations-viewed', { items: this.products, listId: 'cart_upsell', listName: 'Cart view: Add to your order' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .upsell-slider {
    margin-top: 15px;
    header {
      padding: 0 20px;
    }
  }
</style>
